import axios from "axios";
import store from "@/store/store";
import { Message, MessageBox } from "element-ui";

let baseApiUrl = "http://apiobs.test.guojutech.net/";
let ssoApiUrl = "http://ssoobs.test.guojutech.net/";
let baseimgUrl = baseApiUrl + "filereso-api/oss/file/viewFile?fileId=";
// let baseApiUrl = 'http://gateway-dev.cqxmgj.lo:9100/'
let baseUploadUrl = baseApiUrl + "filereso-api/oss/file/upload?dirName=";
if (process.env.NODE_ENV != "development") {
  let env = require("../config/env");
  baseApiUrl = env.API_URL;
  baseUploadUrl = env.API_URL + "filereso-api/oss/file/upload?dirName=";
  ssoApiUrl = env.SSO_URL;
  baseimgUrl = env.API_URL + "filereso-api/oss/file/viewFile?fileId=";
}

// export const BaseUrl =  baseApiUrl + '/jyxm-boss';
export const BaseUrl = baseApiUrl;
export const uploadUrl = (fileId) => baseUploadUrl + fileId;
export const imgUrl = baseimgUrl;
export const abbvImgUrl = (fileId) => baseimgUrl + fileId;
export let syncFileUrl = (fileId) =>
  `https://api-dev.guojutech.net/factoring-boss/file/${fileId}`;
// export const BaseUrl = process.env.BASE_URL;
axios.defaults.withCredentials = true;

const CancelToken = axios.CancelToken;
export const source = CancelToken.source();

// 创建axios实例
const service = axios.create({
  baseURL: BaseUrl,
  // url: baseUrl,    // api的base_url
  // timeout: 10000, // 请求超时时间（毫秒）
  withCredentials: true, //请求是否携带凭证
});
const serviceSso = axios.create({
  baseURL: ssoApiUrl,
  // url: baseUrl,    // api的base_url
  // timeout: 10000, // 请求超时时间（毫秒）
  withCredentials: true, //请求是否携带凭证
});
let storeXAuthToken = (response) => {
  let xAuthToken = response.headers["x-auth-token"];
  if (response.headers.hasOwnProperty("x-auth-token")) {
    if (xAuthToken != null) {
      localStorage.setItem("x-auth-token", xAuthToken);
    } else {
      localStorage.removeItem("x-auth-token");
    }
  }
};
let headerXAuthToken = (config) => {
  let xAuthToken = localStorage.getItem("x-auth-token");
  if (xAuthToken != null) {
    config.headers["x-auth-token"] = xAuthToken;
  }
};
// request拦截器
service.interceptors.request.use(
  (config) => {
    headerXAuthToken(config);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//
serviceSso.interceptors.response.use(
  (response) => {
    response.headers["Content-type"] = "application/json;charset=UTF-8";
    storeXAuthToken(response);
    return response;
  },
  (error) => {
    if (!error.response) {
      return Promise.reject(error);
    }
    // store.dispatch('handIsLoading', false);
    return Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    response.headers["Content-type"] = "application/json;charset=UTF-8";
    storeXAuthToken(response);

    if (response.data.code === 302 && response.data.msg == "oauth2") {
      window.location.href = response.data.data.location;
      return;
    }
    return response;
  },
  (error) => {
    if (!error.response) {
      return Promise.reject(error);
    }
    const res = error.response.data;
    if (res.status === 40101 || res.status === 401) {
      // 登录超时或账号已在别处登录
      Message({
        message: res.message,
        type: "error",
        duration: 5 * 1000,
      });
      MessageBox.confirm(
        "你已被登出，可以取消继续留在该页面，或者重新登录",
        "确定登出",
        {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        loginOut();
      });
    }
    if (res.status === 40311) {
      Message({
        message: "当前用户无相关操作权限！",
        type: "error",
        duration: 5 * 1000,
      });
      loginOut();
    }
    if (res.status === 40001) {
      Message({
        message: "账户或密码错误！",
        type: "warning",
      });
    }
    if (
      error.response.data &&
      (res.status === 200 ||
        res.data === 304 ||
        res.data === 302 ||
        res.data === 400 ||
        res.data === 500)
    ) {
      Message({
        message: res.msg,
        type: "warning",
      });
    }
    // store.dispatch('handIsLoading', false);
    return Promise.reject(error);
  }
);

//登出，回到登陆页
function loginOut() {
  store.dispatch("LogOut").then((res) => {
    // this.$router.push('/');
    // location.reload();
  });
}

export default service;
//发送数据方式为get，其格式为org?id=1(对象格式)
export function fetchGet(url, params, config) {
  return new Promise((resolve, reject) => {
    service
      .get(
        url,
        {
          params: params,
        },
        config
      )
      .then(
        (response) => {
          if (response) {
            resolve(response.data);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
export function fetchGetSso(url, params, config) {
  return new Promise((resolve, reject) => {
    serviceSso
      .get(
        url,
        {
          params: params,
        },
        config
      )
      .then(
        (response) => {
          if (response) {
            resolve(response.data);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function fetchPostSso(url, params, config) {
  return new Promise((resolve, reject) => {
    serviceSso
      .post(url, params, config)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function fetchPost(url, params, config) {
  return new Promise((resolve, reject) => {
    service
      .post(url, params, config)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
export function fetchPostImg(url, params, config) {
  return new Promise((resolve, reject) => {
    service
      .post(url, params, config)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
export function fetchPostUrl(url, params, config) {
  return new Promise((resolve, reject) => {
    let ret = "";
    for (let it in params) {
      ret +=
        encodeURIComponent(it) + "=" + encodeURIComponent(params[it]) + "&";
    }
    ret = ret.slice(0, -1);
    url = url + "?" + ret;
    service
      .post(url, params, config)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
export function fetchPostForm(url, params, config) {
  return new Promise((resolve, reject) => {
    config.headers["Content-type"] = "application/x-www-form-urlencoded";
    config.transformRequest = function(params) {
      let ret = "";
      for (let it in params) {
        ret +=
          encodeURIComponent(it) + "=" + encodeURIComponent(params[it]) + "&";
      }
      return ret;
    };
    service
      .post(url, params, config)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function fetchPostFormData(url, params, config) {
  return new Promise((resolve, reject) => {
    let formData = new FormData();
    for (let i in params) {
      formData.append(i, params[i]);
    }
    service
      .post(url, formData, config)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

//和以post形式发送数据一样
export function fetchPut(url, params, config) {
  return new Promise((resolve, reject) => {
    service
      .put(url, params, config)
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function fetchDel(url, params, config) {
  return new Promise((resolve, reject) => {
    service
      .delete(url, params, config)
      .then(
        (response) => {
          if (response) {
            resolve(response.data);
          }
        },
        (err) => {
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
